import React from "react";
import { StoryProducer } from "../../storyproducer/views/StoryProducer";

export const ShowRunnerLayout: React.FC = () => <StoryProducer mode="showrunner" />;
